export const REFRESH_BROADCAST_DONE_TOAST = {
  color: 'green',
  message: 'המסך רוענן: הרענון נשלח לכל המכשירים',
  autoClose: 3000,
} as const;

export const REFRESH_BROADCAST_FAILED_TOAST = {
  color: 'red',
  title: 'שגיאה',
  message: 'שליחת הרענון נכשלה',
  autoClose: 3000,
} as const;

export const REFRESH_MANAGER_NOW_TOAST = {
  color: 'blue',
  message: 'המנהל ביקש רענון — מרענן…',
  autoClose: 3000,
} as const;

export const REFRESH_MANAGER_DEFERRED_TOAST = {
  color: 'orange',
  message: 'המנהל ביקש רענון — יבוצע בסיום הפעולה',
  autoClose: 3000,
} as const;

export const REFRESH_SELF_DEFERRED_TOAST = {
  color: 'orange',
  message: 'הרענון יבוצע בסיום הפעולה הנוכחית',
  autoClose: 3000,
} as const;

// Shown only when VERSION_REFRESH_HEADS_UP_MS > 0; a forced version reload is otherwise silent.
export const REFRESH_VERSION_HEADS_UP_TOAST = {
  color: 'blue',
  message: 'גרסה חדשה — המסך מתרענן',
  autoClose: 3000,
} as const;

export const REFRESH_DONE_TOAST = {
  color: 'green',
  message: 'המסך רוענן',
  autoClose: 3000,
} as const;

export const REFRESH_VERSION_DONE_TOAST = {
  color: 'green',
  message: 'המסך רוענן — גרסה חדשה זוהתה',
  autoClose: 3000,
} as const;

export const REFRESH_SESSION_CLOSED_DONE_TOAST = {
  color: 'green',
  message: 'המסך רוענן — סגירת קופה התבצעה',
  autoClose: 3000,
} as const;

export const REFRESH_SESSION_OPENED_DONE_TOAST = {
  color: 'green',
  message: 'המסך רוענן — פתיחת קופה התבצעה',
  autoClose: 3000,
} as const;

// sessionStorage key + values for the post-reload notice (a reload destroys any pre-reload toast).
export const REFRESH_NOTICE_KEY = 'pos.refreshNotice';
export type RefreshNotice =
  | 'now'
  | 'deferred'
  | 'version-now'
  | 'session-closed'
  | 'session-opened';
// Marks the broadcast initiator (timestamp) so it shows ONE combined toast post-reload.
export const REFRESH_INITIATOR_KEY = 'pos.refreshInitiator';
export const REFRESH_INITIATOR_MAX_AGE_MS = 120_000;
// Cross-tab pulse so non-POS screens (dashboard/home/gate) can refresh alongside POS/KDS.
export const REFRESH_CROSS_TAB_PULSE_KEY = 'pos.refreshPulse';
